var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-circle",class:{empty: !_vm.color && !_vm.color2},style:({background: _vm.color})},[(_vm.color2)?_c('div',{staticClass:"color2",style:({background: _vm.color2})}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }